
















































import { computed, defineComponent, watchEffect } from '@vue/composition-api';
import FindMarkerButton from '@/components/map/FindMarkerButton.vue';
import OfflineMapButton from '@/components/map/OfflineMapButton.vue';
import { getTableCellComponents, tableHeaders } from '@/store/modules/fieldsView/configuration';
import { SortDirOptions } from '@/store/modules/fieldsView/index';
import { useGroups } from '@/store/modules/group';
import { useAllResources } from '@/store/modules/resources';
import FieldsViewControls from '../FieldsViewControls/FieldsViewControlsDesktop.vue';
import FieldStatusCell from './FieldStatusCell.vue';
import TextCell from './TextCell.vue';

export default defineComponent({
	components: {
		FieldsViewControls,
		FieldStatusCell,
		TextCell,
		OfflineMapButton,
		FindMarkerButton,
	},
	setup(_, { root }) {
		const { isLoaded: areGroupsLoaded, isLoading: areGroupsLoading, hasError: groupsHaveError } = useGroups(
			root.$store
		);
		const {
			isLoaded: areResourcesLoaded,
			isLoading: areResourcesLoading,
			hasError: resourcesHaveError,
			fields,
		} = useAllResources(root.$store);
		const isLoaded = computed(() => areGroupsLoaded.value && areResourcesLoaded.value);
		const isLoading = computed(() => areGroupsLoading.value || areResourcesLoading.value);
		const hasError = computed(() => groupsHaveError.value || resourcesHaveError.value);
		const fieldRows = computed(() => root.$store.getters['fieldsView/getFieldRows']);
		const sortBy = computed(() => root.$store.getters['fieldsView/getSortBy']);
		const sortDir = computed(() => root.$store.getters['fieldsView/getSortDir']);
		const activeFieldId = computed(() => root.$store.getters['fieldsView/getActiveFieldId']);
		const tableCellComponents = getTableCellComponents();
		const activeFieldRowVisible = computed<boolean>(() => root.$store.getters['fieldsView/getActiveFieldRowVisible']);

		const getIconConfig = (key: any) => {
			if (sortBy.value !== key) {
				return {
					icon: 'mdi-arrow-down',
					color: 'grey lighten-1',
				};
			} else {
				return {
					color: 'grey darken-3',
					icon: sortDir.value === 'ASC' ? 'mdi-arrow-up' : 'mdi-arrow-down',
				};
			}
		};

		const getNextSortDir = (sortDir: SortDirOptions) => {
			switch (sortDir) {
				case 'DESC':
					return 'ASC';
				case 'ASC':
					return null;
				case null:
				default:
					return 'DESC';
			}
		};

		const handleSort = (key: string) => {
			if (sortBy.value !== key) {
				root.$store.dispatch('fieldsView/changeSort', { sortBy: key, sortDir: 'DESC' });
			} else {
				const nextSortDir = getNextSortDir(sortDir.value);
				root.$store.dispatch('fieldsView/changeSort', {
					sortBy: nextSortDir === null ? null : key,
					sortDir: nextSortDir,
				});
			}
		};

		const hasAccessToFields = computed(() => isLoaded.value && fields.value.length > 0);

		watchEffect(() => {
			if (!activeFieldRowVisible.value) {
				root.$store.dispatch('fieldsView/clearActiveFieldId');
			}
		});

		return {
			isLoading,
			isLoaded,
			hasError,
			sortBy,
			sortDir,
			getNextSortDir,
			handleSort,
			fieldRows,
			tableHeaders: Object.values(tableHeaders),
			tableCellComponents,
			hasAccessToFields,
			getIconConfig,
			activeFieldId,
		};
	},
});
